/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
// import { RawLocation, Route } from "vue-router";

// Let's avoid vue dependencies in shared code
type Route = any;
type RawLocation = any;

/** Placed here, since this is used both in vue-frontend and React projects */
export class VueRouteSerializer {
  public static saveRoute(route: Route): void {
    const obj: RawLocation = {
      name: route.name,
      path: route.path,
      params: route.params,
      query: route.query,
    };
    const serialized = JSON.stringify(obj);
    sessionStorage.setItem("nextRoute", serialized);
  }

  public static saveReactRoute(route: { search: string; pathname: string }): void {
    const queryParams = Object.fromEntries(new URLSearchParams(route.search));

    const obj: RawLocation = {
      name: "",
      path: route.pathname,
      params: {},
      query: queryParams,
    };
    const serialized = JSON.stringify(obj);
    sessionStorage.setItem("nextRoute", serialized);
  }

  public static loadSavedRoute(): RawLocation | undefined {
    const serialized = sessionStorage.getItem("nextRoute");
    if (serialized) {
      return <RawLocation>JSON.parse(serialized);
    }
    return undefined;
  }
}
